/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ID({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#ID_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M.9 3.5A2.6 2.6 0 0 1 3.5.9h9a2.6 2.6 0 0 1 2.6 2.6v9a2.6 2.6 0 0 1-2.6 2.6h-9a2.6 2.6 0 0 1-2.6-2.6zm2.6-1.4a1.4 1.4 0 0 0-1.4 1.4v9a1.4 1.4 0 0 0 1.4 1.4h9a1.4 1.4 0 0 0 1.4-1.4v-9a1.4 1.4 0 0 0-1.4-1.4zm1.876 2.588a.688.688 0 1 0-1.376 0v6.624a.688.688 0 1 0 1.376 0zM7.508 12h1.308q.99 0 1.703-.48.715-.48 1.097-1.38Q12 9.244 12 7.993q0-1.245-.384-2.14-.382-.895-1.09-1.372Q9.815 4 8.834 4H7.508a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1m1.25-1.45h-.874v-5.1h.878q.61 0 1.026.265.417.266.626.828.213.562.213 1.45 0 .894-.213 1.46-.21.562-.63.832-.415.266-1.026.266" clipRule="evenodd" /></g><defs><clipPath id="ID_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;